import { ImageOptimization } from '@components/image-optimization'
import { Button } from '@components/v2/button'
import { TextBase } from '@components/v2/text-base'
import { Title } from '@components/v2/title'
import styles from './styles.module.scss'

interface Props {
  smoothScroll?: () => void
}

export const SectionFreeMarketWithSecurity = ({ smoothScroll }: Props) => {
  return (
    <div className={styles.wrapperContainer}>
      <div className="flex flex-col lg:px-3">
        <div className="w-full max-w-7xl self-center lg:grid lg:grid-cols-12">
          <div className={styles.container}>
            <div className={styles.wrapperInfos}>
              <Title className={styles.title} level="h2">
                <>
                  Como migrar para o{' '}
                  <span className="text-orange">Mercado Livre</span> de energia
                  com segurança?
                </>
              </Title>
              <TextBase className={styles.description}>
                Para migrar para o Mercado Livre de Energia com segurança,
                oferecemos a solução perfeita de migração tranquila e fácil.
                <br />
                Conte com o auxílio dos especialistas do
                <strong> Portal Solar!</strong>
              </TextBase>
            </div>
            <div className={styles.backgroundImage}>
              <picture>
                <source
                  media="(min-width: 640px)"
                  srcSet={`/assets/ipad/como-migrar-para-o-mercado-livre-de-energia.webp`}
                />
                <ImageOptimization
                  src={`/assets/mobile/como-migrar-para-o-mercado-livre-de-energia.webp`}
                  alt="Como migrar para o mercado livre de energia"
                />
              </picture>
            </div>
            <div>
              <Button type="button" onClick={smoothScroll}>
                Conheça nossas soluções
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
